import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import ImportDepartmentModal from "./partials/ImportDepartmentModal";

import {
    getPreRegistrationConfigurations as onGetPreRegistrationConfigurations,
    addNewPreRegistrationConfiguration as onAddNewPreRegistrationConfiguration,
    updatePreRegistrationConfiguration as onUpdatePreRegistrationConfiguration,
    deletePreRegistrationConfiguration as onDeletePreRegistrationConfiguration,

    getMentions as onGetMentions,

} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const PreRegistrationConfiguration = () => {

    //meta title
    document.title = "Configuration des pré-inscriptions | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [preRegistrationConfiguration, setPreRegistrationConfiguration] = useState(null);

    const [modalOpen, setModalOpen] = useState(false);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            id: (preRegistrationConfiguration && preRegistrationConfiguration.id) || '',
            uid: (preRegistrationConfiguration && preRegistrationConfiguration.uid) || '',
            start_date: (preRegistrationConfiguration && preRegistrationConfiguration.start_date) || '',
            end_date: (preRegistrationConfiguration && preRegistrationConfiguration.end_date) || '',
            mention_id: (preRegistrationConfiguration && preRegistrationConfiguration.mention_id) || '',
            maximum_age: (preRegistrationConfiguration && preRegistrationConfiguration.maximum_age) || '',
            
            
        },
        validationSchema: Yup.object({
           
            start_date: Yup.date().required("Veuillez saisir la date de début"),
            end_date: Yup.date().required("Veuillez saisir la date de fin"),
            maximum_age: Yup.number().required("Veuillez saisir l'âge maximale"),
            mention_id: Yup.number().required("Veuillez sélectionner la mention"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updatePreRegistrationConfiguration = {
                    id: values.id,
                    uid: values.uid,
                    start_date: values.start_date,
                    end_date: values.end_date,
                    maximum_age: values.maximum_age,
                    mention_id: values.mention_id,
                    

                    
                };
                // update movie category
                dispatch(onUpdatePreRegistrationConfiguration(updatePreRegistrationConfiguration));
                validation.resetForm();
            } else {
                const newPreRegistrationConfiguration = {
                    //id: values["id"],
                    //uid: values["uid"],
                    start_date: values["start_date"],
                    end_date: values["end_date"],
                    mention_id: values["mention_id"],
                    maximum_age: values["maximum_age"],
                    

                };
                // save new movie category
                dispatch(onAddNewPreRegistrationConfiguration(newPreRegistrationConfiguration));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const PreRegistrationConfigurationProperties = createSelector(
        (state) => state.preRegistrationConfigurationReducer, // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
        (preRegistrationConfigurationReducer) => ({
            preRegistrationConfigurations: preRegistrationConfigurationReducer.preRegistrationConfigurations,
            loading: preRegistrationConfigurationReducer.loading
        })
    );

    const {preRegistrationConfigurations, loading} = useSelector(PreRegistrationConfigurationProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {

        
        if (preRegistrationConfigurations && !preRegistrationConfigurations.length) {
           
            dispatch(onGetPreRegistrationConfigurations());
        }
    }, [dispatch, preRegistrationConfigurations]);


    // Mentions
        const MentionProperties = createSelector(
            (state) => state.mentionReducer, 
            (mentionReducer) => ({
                mentions: mentionReducer.mentions,
                loading: mentionReducer.loading
            })
        );
    
        const {mentions} = useSelector(MentionProperties);
    
    
        
    
        useEffect(() => {
            if (mentions && !mentions.length) {
                dispatch(onGetMentions());
            }
        }, [dispatch, mentions]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setPreRegistrationConfiguration(null);
        } else {
            setModal(true);
        }
    };



    const handlePreRegistrationConfigurationClick = arg => {
        const preRegistrationConfiguration = arg;
        setPreRegistrationConfiguration({
            id: preRegistrationConfiguration.id,
            uid: preRegistrationConfiguration.uid,
            start_date: preRegistrationConfiguration.start_date,
            end_date: preRegistrationConfiguration.end_date,
            maximum_age: preRegistrationConfiguration.maximum_age,
            mention_id: preRegistrationConfiguration.mention_id,
            

        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (branch) => {
        setPreRegistrationConfiguration(branch);
        setDeleteModal(true);
    };

    const handleDeletePreRegistrationConfiguration = () => {
        if (preRegistrationConfiguration && preRegistrationConfiguration.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeletePreRegistrationConfiguration(preRegistrationConfiguration));
            setDeleteModal(false);
        }
    };

    const onClickNewPreRegistrationConfiguration = () => {
        setIsEdit(false);
        setPreRegistrationConfiguration(null);
        toggle();
        //setModal(true)
    };

    

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Date début",
                accessorKey: "start_date",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Date fin",
                accessorKey: "end_date",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Âge maximale",
                accessorKey: "maximum_age",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Mention",
                accessorKey: "mention.title",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handlePreRegistrationConfigurationClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeletePreRegistrationConfiguration}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Configuration préinscriptions" breadcrumbItem="Liste des configurations" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="d-flex gap-2">
                                                  

                                                    <Link to="#!" onClick={onClickNewPreRegistrationConfiguration} className="btn btn-primary me-1">Ajouter une configuration</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={preRegistrationConfigurations || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Configuration" : "Ajouter - Configuration"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                        
                                        <div className="mb-3">
                                            <Label>Date début</Label>
                                            <Input
                                                name="start_date"
                                                type="date"
                                                placeholder="Date début"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.start_date || ""}
                                                invalid={
                                                    validation.touched.start_date && validation.errors.start_date ? true : false
                                                }
                                            />
                                            {validation.touched.start_date && validation.errors.start_date ? (
                                                <FormFeedback type="invalid">{validation.errors.start_date}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Date fin</Label>
                                            <Input
                                                name="end_date"
                                                type="date"
                                                placeholder="Date fin"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.end_date || ""}
                                                invalid={
                                                    validation.touched.end_date && validation.errors.end_date ? true : false
                                                }
                                            />
                                            {validation.touched.end_date && validation.errors.end_date ? (
                                                <FormFeedback type="invalid">{validation.errors.end_date}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Âge maximale</Label>
                                            <Input
                                                name="maximum_age"
                                                type="numeric"
                                                placeholder="Âge maximale"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.maximum_age || ""}
                                                invalid={
                                                    validation.touched.maximum_age && validation.errors.maximum_age ? true : false
                                                }
                                            />
                                            {validation.touched.maximum_age && validation.errors.maximum_age ? (
                                                <FormFeedback type="invalid">{validation.errors.maximum_age}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Mention</Label>
                                            <Input
                                                name="mention_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.mention_id || ""
                                                }
                                                invalid={
                                                    validation.touched.mention_id && validation.errors.mention_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {mentions.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.title}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.mention_id && validation.errors.mention_id ? (
                                                <FormFeedback type="invalid">{validation.errors.mention_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        

                                        
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />

          
        </React.Fragment>
    );
}


export default PreRegistrationConfiguration;